import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import images from 'assets/Images';
import { sidebarMenu, adminSidebarMenu } from 'config';
import classNames from 'classnames';
import { useFetch } from 'hooks';
import { useDispatch } from 'react-redux';
import { referenceDataSlice, factListSlice, routeSlice, clientSlice, clientListSlice } from 'redux/reducers';
import { motion } from 'framer-motion';
import './style.scss';

const ulVariants = {
	open: {
		display: 'block',
		delay: 1,
		visibility: 'visible',
		opacity: 1,
		transition: {
			delay: 0.1,
			staggerChildren: 0.17,
			delayChildren: 0.2
		}
	},
	closed: {
		display: 'none',
		opacity: 0,
		transition: {
			staggerChildren: 0.05,
			staggerDirection: -1,
			display: {
				when: 'afterChildren'
			}
		}
	}
};

const Sidebar = () => {
	const [activeTab, setActiveTab] = useState(null);
	const [showSidebar, setShowSidebar] = useState(false);
	const dispatch = useDispatch();
	const api = useFetch();

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const loc = location?.pathname;
		setActiveTab(loc?.slice(1, loc?.length));
	}, [location]);

	const setBaseData = async () => {
		const refData = await api({ url: 'referenceData/v1', method: 'get' });
		dispatch(referenceDataSlice?.actions?.referenceDataReducer(refData?.data?.data));

		const { data } = await api({ url: `client/v1?c_id=${localStorage.getItem('c_id')}`, method: 'get' });
		const clientConfig = data?.data;
		dispatch(clientSlice?.actions?.clientReducer(clientConfig));

		const factList = await api({ url: 'factManagement/v1/factList', method: 'post', data: { sort: [{ id: 'fa_name', value: 1 }] } });
		dispatch(factListSlice?.actions?.factListReducer(factList?.data?.data[0]?.result));

		if (process.env.REACT_APP_STANDALONE_APP !== 'Y') {
			const { data: clientList } = await api({ url: `client/v1/list`, method: 'post' });
			dispatch(clientListSlice?.actions?.clientListReducer(clientList?.data?.result));
		} else {
			clientConfig?.c_formData?.op_status !== 'COM' && navigator('');
		}
	};

	useEffect(() => {
		setBaseData();
	}, []);

	const setTab = e => {
		setActiveTab(e?.key);
		!e?.submenu && navigator(e?.key);
	};

	const navigator = key => {
		dispatch(routeSlice?.actions?.routeReducer(key));
		navigate(`/${key}`);
	};

	const displaySubsections = el => {
		return el?.submenu?.find(e => e?.key === activeTab);
	};

	const showSidebarHandler = () => {
		setShowSidebar(true);
	};

	const userSidebarMenu = () => {
		return sidebarMenu.filter((el) => el.key !== "user-management");
	}

	return (
		<motion.div
			className='sidebar'
			initial={{ width: 65 }}
			animate={{ opacity: 1, transition: { opacity: { duration: 0.25, delay: 0.15 } } }}
			exit={{ opacity: 0, transition: { opacity: { duration: 0.25 } } }}
			whileHover={{ width: 280 }}
			onHoverStart={showSidebarHandler}
			onHoverEnd={() => setShowSidebar(false)}
		>
			<aside>
				<div className='sidebar__appname'>
					<img className='sidebar__appimg' src={images.appLogo} />
					<motion.span variants={ulVariants} animate={showSidebar ? 'open' : 'closed'} className='sidebar__menu'>
						Click.ezee Studio
					</motion.span>
				</div>
				<nav>
					<ul className='sidebar__container scroll-bar'>
						{(localStorage.getItem('_am') === 'true' ? adminSidebarMenu : localStorage.getItem('_cl') === 'true' ? sidebarMenu : userSidebarMenu())?.map((el, i) => (
							<li key={i}>
								<motion.div whileTap={{ scale: 0.4 }} className={classNames({ sidebar__item: true, 'sidebar--active': activeTab === el?.key })} onClick={() => setTab(el)}>
									<img className='sidebar__img' src={images[el?.key]} />
									<motion.span variants={ulVariants} animate={showSidebar ? 'open' : 'closed'} className='sidebar__menu'>
										{el?.value}
									</motion.span>
								</motion.div>
								{((el.submenu && activeTab === el?.key) || displaySubsections(el)) && (
									<ul className={classNames({ sidebar__submenu: true, 'scroll-bar': true })}>
										{el.submenu?.map((elm, j) => (
											<li key={j} className='sidebar__sublist--content' onClick={() => setTab(elm)}>
												<motion.div variants={ulVariants} animate={showSidebar ? 'open' : 'closed'} className={classNames({ sidebar__sublist: true, sidebar__item: true, 'sidebar--active': activeTab === elm?.key })}>
													<img className='sidebar__subimg' src={images[elm?.key]} />
													<span className='sidebar__menu'>{elm?.value}</span>
												</motion.div>
											</li>
										))}
									</ul>
								)}
							</li>
						))}
					</ul>
				</nav>
			</aside>
		</motion.div>
	);
};

export default Sidebar;
